import {
  type LocationDomainSelectModel,
  LocationId,
  PlaceId,
} from '@mntn-dev/domain-types'
import { uuid } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'

export const MockLocation = MockModel<LocationDomainSelectModel>(
  ({
    locationId = LocationId(),
    placeId = PlaceId(uuid().replace(/-/g, '')),
    name = `Place ${placeId}`,
  }) => {
    return {
      locationId,
      placeId,
      name,
    } satisfies LocationDomainSelectModel
  }
)
